import React from 'react';

import { Typography } from '~/packages/common-frontend/components/Typography';
import { ColorScheme } from '~/packages/common-frontend/theme';
import { useSimpleColorMode } from '~/packages/common-frontend/theme/utils';

type CounterProps = {
  count: number;
  colorScheme?: ColorScheme;
};
export const Counter = ({ count, colorScheme = 'gray' }: CounterProps) => {
  const mode = useSimpleColorMode();
  return (
    <Typography
      inline
      colorScheme={colorScheme}
      fontWeight="semibold"
      TextProps={{
        padding: '0.125rem 0.5rem',
        borderRadius: '0.25rem',
        backgroundColor: mode(`${colorScheme}.50`, `${colorScheme}.950`),
      }}
    >
      {count}
    </Typography>
  );
};
